import React, {useEffect, useState} from "react";
import {useSelector} from "inbooma-api";
import FormItem from "../../../components/FormItem";
import LocationsChange from "./behaviors/LocationsChange";
import GetValidDates from "./behaviors/GetValidDates";
import TimeInput from 'react-time-input';
import {_getObjectFromArray, in_array} from "../../../../utils/Helper";
import t from "../../../helpers/t";

const ItemView = (props) => {
    const { dispatch, visualInspection, visualInspectionItemsActions,visualInspectionsActions,requestPath, locations, Biscuit, moment, t, language,currentUrl,rbac, showNotification} = props;
    const [savePending, setSavePending] = useState(false);
    const _editVisualInspection = useSelector(state => state['visual_inspections_data'].patchVisualInspection);
    const _addVisualInspection = useSelector(state => state['visual_inspections_data'].addVisualInspection);
    const _addVisualInspections = useSelector(state => state['visual_inspections_data'].addVisualInspections);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [edit, setEdit] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const itemTemp ={
                client_id: Biscuit.get('user.client_id'),
                begin: moment().format('YYYY-MM-DD 00:00:00'),
                end: new Date(),
                date: new Date()
            };
    const [item, setItem] = useState(null);
    const [visualInspections, setVisualInspections] = useState([]);
    const [saveState, setSaveState] = useState(null);
    const [multi,setMulti] = useState(false);
    useEffect(() => {
        if(item === null && !savePending) {
            let locationsList = _getObjectFromArray(locations);

            if (typeof visualInspection.id !== 'undefined') {
                let clone = {};
                setEdit(true);
                Object.assign(clone, visualInspection);
                //clone = visualInspection;
                let l = [];
                if (typeof visualInspection.visual_inspection_items !== 'undefined' && visualInspection.visual_inspection_items.length > 0) {
                    clone.begin = visualInspection.visual_inspection_items[0].begin;
                    clone.end = visualInspection.visual_inspection_items[0].end;
                    visualInspection.visual_inspection_items.map(vI => {
                        if(vI.location_id !== null && !in_array(vI.location_id,l)) {
                            l.push(locationsList[vI.location_id]);
                        }
                    });
                    setSelectedLocations(l);
                } else {
                    clone.begin = clone.end = moment().format('YYYY-MM-DD HH:mm');
                }
                setSelectedDate(new Date(clone.date));
                setItem(clone);
                setSaveState(clone);
            } else {
                setItem(itemTemp);
                setSaveState(itemTemp);
            }
        }
    },[])


    const setItems = (date = null) => {
        let items = [], l= [], c= [];
        if(selectedLocations.length === 0){
            l = [];
            locations.map(ls => {
                l.push(ls);
            })
        }else { l=[...selectedLocations];}

            l.map(location => {
                let cItem = {
                    location_id: location.id,
                    begin: (multi?moment(date).format('YYYY-MM-DD')+' '+moment(item.begin).format('HH:mm'):item.begin),
                    end: (multi?moment(date).format('YYYY-MM-DD')+' '+moment(item.end).format('HH:mm'):item.end)
                }
                if(typeof item.id !== 'undefined'){
                    cItem['visual_inspection_id'] = item.id;
                }
                items.push(cItem)
            });

        return items;
    };

    const onSubmit = () => {
        if(!multi) {
            const clone = {};
            Object.assign(clone, item);
            if (typeof clone.date === 'object') {
                clone.date = moment(clone.date).format('YYYY-MM-DD 00:00:00');
            }
            clone['visual_inspection_items'] = setItems();
            setItem(clone);
            if (edit) //edit
            {
                dispatch(visualInspectionsActions.patchVisualInspection(
                    {
                        token: Biscuit.get('token'),
                        data: clone,
                        id: item.id,
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }
                ));
                setSavePending(true);
            } else {  //add
                dispatch(visualInspectionsActions.addVisualInspection(
                    {
                        token: Biscuit.get('token'),
                        data: clone,
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }
                ));
                setSavePending(true);
            }
        } else {
            if(visualInspections.length < 1){
                showNotification('warning',null,t('no dates selected'));
                return;
            }
            const clone = [...visualInspections];

            clone.map((vI, key) => {
                clone[key]['visual_inspection_items'] = setItems(vI.date);
            });
            dispatch(visualInspectionsActions.addVisualInspections(
                {
                    token: Biscuit.get('token'),
                    data: {data:clone},
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setSavePending(true);
        }
    };

    useEffect(() => {
        if(!savePending || _editVisualInspection.success === ''){
            return;
        }
        if(_editVisualInspection.success === true){
            showNotification('success',visualInspection.id);
            close(true);
        } else {
            showNotification('warning',null,_editVisualInspection.data.message);
        }
    },[_editVisualInspection]);

    useEffect(() => {
        if(!savePending || _addVisualInspection.success === ''){
            return;
        }
        if(_addVisualInspection.success === true){
            showNotification('success',_addVisualInspection.data.id);
            close(true);
        } else {
            showNotification('warning',null,_addVisualInspection.data.message);
        }
    },[_addVisualInspection]);

    useEffect(() => {
        if(!savePending || _addVisualInspections.success === ''){
            return;
        }
        if(_addVisualInspections.success === true){
            showNotification('success',t('multiple visual inspections'));
            close(true);
        } else {
            showNotification('warning',null,_addVisualInspections.data.message);
        }
    },[_addVisualInspections]);

    const getLocationById = (id) => {

        if (id === undefined || id == null || locationsList === undefined) return '';

        if (locationsList[id] !== undefined && locationsList[id] != null) return locationsList[id];
        else return '';
    };

    const onToggleMulti = (e) => {
       setMulti(e.target.checked);
    }

    const close = (comeFromSave = false) => {
        let changes = false;
        for (const [key, value] of Object.entries(saveState)) {
            if (value !== item[key]) {
                changes = true;
            }
        }
        let bestaetigung = (!changes || comeFromSave)?true:window.confirm('Es gibt ungespeicherte Daten, soll das Formular dennoch geschlossen werden?');
        if (bestaetigung) {
            dispatch(visualInspectionItemsActions.getVisualInspectionItemResetData());
            dispatch(visualInspectionsActions.getVisualInspectionsResetData());
            dispatch(visualInspectionsActions.getVisualInspectionResetData());
            let returnUrl = (typeof requestPath !== 'undefined') ? requestPath + currentUrl.search : `/visual_inspections${currentUrl.search}`;
            window.location.replace(returnUrl);
        }
    };

    const onChangeField = (e,name) =>
    {
        if(e.length === 5) {
            let clone = {};
            Object.assign(clone, item);
            clone[name] = moment(item.date).format('YYYY-MM-DD') + ' ' + e;
            setItem(clone);
        }
    }

    const onDateChangedHandler = (e) => {
        const clone = {};
        let date = e;
        if(typeof e.target !== 'undefined'){
            if(e.target.value === null) return;
            date = new Date(e.target.value);
        }
        Object.assign(clone,item);
        clone.date = moment(date).format('YYYY-MM-DD 00:00:00');
        clone.begin = moment(date).format('YYYY-MM-DD') + ' ' + moment(item.begin).format('HH:mm');
        clone.end = moment(date).format('YYYY-MM-DD') + ' ' + moment(item.end).format('HH:mm');
        setSelectedDate(date);
        setItem(clone);
    }

    const abortButtonRef = React.createRef();
    return (<>
        <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" aria-hidden="false">
            {item !== null && <><header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                <h1 className="inb-page-title">{edit ? t('edit_${a}',{a:t('visual_inspection')}) : t('add_${a}',{a:t('visual_inspection')})}</h1>
                <div className="off-canvas__actions column">
                    <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title={t('save')} onClick={onSubmit}>
                        {!savePending &&
                            <>
                                <i className="fi fi-check"> </i>
                                <span>{t('save')}</span>
                            </>
                        }
                        {savePending &&
                            <span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} />{t('save')}</span>
                        }
                    </button>
                    <a
                        href='#'>
                        <button ref={abortButtonRef} type="button" id="inb-tasksform-abort-button" className="button hollow secondary right button-abort round" title={t('close_window')} onClick={() => close()}>
                            <i className="fi fi-x"> </i>
                        </button>
                    </a>
                </div>
            </header></>}
            {edit && <><p className="off-canvas__subtitle off-canvas__header-region">
                {typeof item.created !== 'undefined' &&
                    t('created_at') + " " + moment(item.created).format('DD.MM.YYYY HH:mm:ss') + " " +
                    t('edited_by') + " " + item.created_by_name + " | " +
                    t('last_modified_at') + " " + moment(item.modified).format('DD.MM.YYYY HH:mm:ss') + " " +
                    t('edited_by') + " " + item.modified_by_name
                }
            </p></>}
            {item !== null ? <>
            <form className="off-content row">
                {rbac.hasPermission('setLocation') && <LocationsChange
                    locations={selectedLocations}
                    setLocations={setSelectedLocations}
                    dispatch={dispatch}
                    visualInspection={item}
                />}
                {!edit && <FormItem
                    type='checkbox'
                    value={multi}
                    id={item.id}
                    name='multi'
                    label={t('Set multi visual inspections')}
                    labelStyle={{minWidth:"240px"}}
                    //htmlFor={t('cancel requested orders')}
                    mediumWidth="12"
                    smallWidth="12"
                    onChangeHandler={onToggleMulti}/>}
                {multi &&
                <GetValidDates
                    t={t}
                    Biscuit={Biscuit}
                    visualInspectionsActions={visualInspectionsActions}
                    dispatch={dispatch}
                    moment={moment}
                    onDateChangedHandler={onDateChangedHandler}
                    setVisualInspections={setVisualInspections}
                    visualInspections={visualInspections}
                    item={item}
                />}
                {!multi &&
                    <FormItem
                        name="date"
                        type="datePicker"
                        label={t('date')}
                        placeholder=""
                        selected={selectedDate}
                        dateFormat="dd.MM.y"
                        datePickerClass="noBorders-noBackground"
                        onChangeHandler={onDateChangedHandler}
                        mediumWidth={4}
                        smallWidth={12}
                        extraTopClasses=""/>
                }
                <div className="list-item-block-offcanvas medium-3 small-6 column">
                    <label>{t('valid_from',null,'capital')}</label>
                    <TimeInput
                        initTime={moment(item.begin).format('HH:mm')}
                        className='input-group-field'
                        mountFocus='true'
                        onTimeChange={(e)=>{onChangeField(e,"begin")}}
                    />
                    {/*<input
                        className="input-group-field"
                        type="time"
                        name="valid_from_time_field"
                        value={moment(item.begin).format('HH:mm')}
                        style={{maxWidth: "40%"}}
                        onChange={(e)=>{onChangeField(e,"begin")}}
                    />*/}
                </div>
                <div className="list-item-block-offcanvas medium-3 small-6 column">
                    <label>{t('valid_to',null,'capital')}</label>
                    <TimeInput
                        initTime={moment(item.end).format('HH:mm')}
                        className='input-group-field'
                        mountFocus='true'
                        onTimeChange={(e)=>{onChangeField(e,"end")}}
                    />
                    {/*<input
                        className="input-group-field"
                        type="time"
                        name="valid_to_time_field"
                        value={moment(item.end).format('HH:mm')}
                        style={{maxWidth: "40%"}}
                        onChange={(e)=>{onChangeField(e,"end")}}
                    />*/}

                </div>


            </form></>
                : <div className="row" style={{textAlign: "center"}}><span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} />{t('loading')}</span></div> }

        </div>
    </>);
}
export default ItemView;